import { useEffect, useRef, useState } from 'react';
import portraitVideo from '../../assets/app-landing/landing_portrait.mp4';
import landscapeVideo from '../../assets/app-landing/landing_landscape.mp4';
import poster from '../../assets/app-landing/landing_poster.jpg';
import logoRackets from '../../assets/app-landing/logo_rackets.png';
import logoPadel from '../../assets/app-landing/logo_padel.svg';
import logoMvp from '../../assets/app-landing/logo_mvp.svg';

const LANDSCAPE_QUERY = '(orientation: landscape)';

// Signed-out welcome screen for the iOS / Android apps (Figma 822:2931). The web keeps LandingPage.
export default function AppVideoLanding({ onGetStarted }) {
  const [isLandscape, setIsLandscape] = useState(() => window.matchMedia?.(LANDSCAPE_QUERY).matches ?? false);
  const videoRef = useRef(null);

  useEffect(() => {
    const mq = window.matchMedia?.(LANDSCAPE_QUERY);
    if (!mq) return undefined;
    const onChange = (e) => setIsLandscape(e.matches);
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, []);

  // The web view pauses the video while the app is in the background; start it again on return
  useEffect(() => {
    const onVisible = () => {
      if (!document.hidden) videoRef.current?.play().catch(() => {});
    };
    document.addEventListener('visibilitychange', onVisible);
    return () => document.removeEventListener('visibilitychange', onVisible);
  }, []);

  return (
    <div className="app-video-landing">
      {/* key swaps the element so the new orientation's file loads and autoplays */}
      <video
        ref={videoRef}
        key={isLandscape ? 'landscape' : 'portrait'}
        className="app-video-landing__video"
        src={isLandscape ? landscapeVideo : portraitVideo}
        poster={poster}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
        aria-hidden="true"
      />
      <div className="app-video-landing__scrim" aria-hidden="true" />

      <div className="app-video-landing__content">
        <div className="app-video-landing__logo" role="img" aria-label="Padel MVP">
          <img src={logoRackets} alt="" className="app-video-landing__rackets" />
          <img src={logoPadel} alt="" className="app-video-landing__padel" width="97.5775" height="26.0977" />
          <img src={logoMvp} alt="" className="app-video-landing__mvp" width="70.1846" height="34.1695" />
        </div>

        <h1 className="app-video-landing__headline">
          Track every score &amp; stat with <span>Padel MVP</span>
        </h1>

        <button type="button" className="btn btn-primary btn-full app-video-landing__cta" onClick={onGetStarted}>
          <span className="btn-text">GET STARTED</span>
        </button>
      </div>
    </div>
  );
}
